export default __webpack_public_path__ + "static/media/w_m_2023_h.2671282f.jpeg";